import { Paper } from '@material-ui/core';
import { WithStyles } from 'decorators/withStyles';
import { IProductNew } from 'interfaces/product';
import React, { Component } from 'react';

import ProductActions from '../Actions';
import ChatsActions from '../Actions/ChatDrawer';
import ExitPopUpCustomizer from '../Actions/ExitPopUpCustomizer';
import MyThemes from '../Actions/MyThemesDrawer';
import ToastActions from '../Actions/ToastDrawer';
import TabContainer from './TabContainer';
import ConfigActions from '../Actions/ConfigDrawer/index';
import ElementsActions from '../Actions/Elements';
import EmailActions from '../Actions/EmailDrawer';
import AcceptMoreThan12Installments from '../Actions/AcceptMoreThan12Installments';
import SunFeaturesList from '../SunFeaturesList';
import BackRedirect from '../Actions/BackRedirect';

interface IState {
  products: IProductNew[];
  filterProducts?: string;
}

interface IProps {
  classes?: any;
}

@WithStyles(() => ({
  containerPaper: {
    fontFamily: 'Lato',
    padding: '24px'
  }
}))
export default class ListProduct extends Component<IProps, IState> {
  render() {
    const { classes } = this.props;

    return (
      <>
        <SunFeaturesList />
        <Paper elevation={0} className={classes.containerPaper}>
          <ProductActions />
          <EmailActions />
          <AcceptMoreThan12Installments />
          <ChatsActions />
          <ToastActions />
          <ConfigActions />
          <ElementsActions />
          <ExitPopUpCustomizer />
          <MyThemes />
          <TabContainer />
          <BackRedirect />
        </Paper>
      </>
    );
  }
}
